import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/**
 * Vertical rhythm + max-width container for one onboarding step's
 * content. Renders the hero (above), the body (here), and the
 * footer (below) with consistent gaps. Card-grid steps (Services,
 * Plan) opt into the `wide` variant for a roomier 880px column.
 */
export function StepShell({
  children,
  variant = "form",
}: {
  children: ReactNode;
  variant?: "form" | "wide";
}) {
  return (
    <div
      className={cn(
        "mx-auto px-6 md:px-10 py-12 md:py-16 space-y-10",
        variant === "wide"
          ? "max-w-[880px]"
          : "max-w-[640px]",
      )}
    >
      {children}
    </div>
  );
}

/**
 * The body slot — the actual step content (form fields, card grid,
 * whatever). Just provides consistent vertical rhythm so siblings
 * like the StepHero and the footer line up across steps.
 */
export function StepBody({ children }: { children: ReactNode }) {
  return <div className="space-y-8">{children}</div>;
}
